import React from 'react';
interface ToggleOption {
  label: string;
  value: boolean;
}
interface ToggleGroupProps {
  value: boolean | null;
  onChange: (value: boolean) => void;
  options?: ToggleOption[];
  error?: boolean;
}
export function ToggleGroup({
  value,
  onChange,
  options = [{
    label: 'Yes',
    value: true
  }, {
    label: 'No',
    value: false
  }],
  error
}: ToggleGroupProps) {
  return <div className="flex space-x-2" data-id="element-312">
      {options.map(opt => {
      const isSelected = value === opt.value;
      return <button key={opt.label} type="button" onClick={() => onChange(opt.value)} aria-pressed={isSelected} className={`
              flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2
              ${isSelected ? 'bg-violet-blue text-white shadow-sm' : 'bg-muted text-muted-foreground hover:bg-muted/80'}
              ${error && !isSelected ? 'border border-destructive' : 'border border-transparent'}
            `} data-id="element-313">
            
            {opt.label}
          </button>;
    })}
    </div>;
}